import styled from 'styled-components';
import { boxFlex } from './../../styled/index';

export const CombosWrapper = styled(boxFlex)`
    margin: 0 0 20px;
`;

export const CombosContent = styled(boxFlex)`
    height: auto;
    width: 100%;
    flex-direction: row;
    justify-content: stretch;
    align-items: flex-start;
    gap: 8px;
    overflow: hidden;
`;
export const CombosCarouselWrapper = styled.div`
    height: auto;
    width: 100%;
    max-width: 100%;
    display: block;
    box-sizing: border-box;
    overflow: hidden;
    @media screen and (min-width: 1001px) {
        &:hover {
            .flicking-arrow {
                cursor: pointer;
                display: flex;
            }
        }
    }
    @media screen and (max-width: 1000px) {
        .flicking-arrow {
            display: flex;
        }
    }
`;

export const CombosContentMobile = styled(boxFlex)`
    overflow-x: auto;
`;
export const CombosContentCarousel = styled(boxFlex)`
    height: auto;
    width: 100%;
`;
